<template>
  <div class="check">
    <el-dialog
      :title="$t('cooperation.dialogTitle.checkResult')"
      :visible.sync="dialogVisible"
      width="50%"
      append-to-body
      :before-close="handleClose"
    >
      <el-progress :percentage="progress" :status="status"></el-progress>
      <!-- 查重结果 -->
      <div class="result" v-if="checkedResult.length">
        <sirui-table
          class="mytable-scrollbar"
          ref="siruiTable"
          :data="checkedResult"
          :paging="false"
          :setting="false"
          :customVisible="false"
          :columns="columnList"
          :height="'350'"
        >
          <vxe-table-column
            v-for="(item, index) in columnList"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title ? $t(item.title) : null"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
          </vxe-table-column>
        </sirui-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cooperation.buttons.cancel') }}</el-button>
        <el-button type="primary" @click="handleClose">{{
          $t('cooperation.buttons.sure')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import API from '@/api/masterData/cooperation';
  import SiruiTable from '@/components/SiruiTable';
  export default {
    name: 'check',
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    components: {
      SiruiTable,
    },
    data() {
      return {
        dialogVisible: false,
        propsData: null,
        progress: 0, // 进度条
        status: null, // 进度条状态
        checkedResult: [], // 查重结果
        columnList: [
          {
            field: 'partnerZhName',
            title: 'cooperation.label.partnerZhName',
            visible: true,
            width: 200,
          },
          {
            field: 'partnerCode',
            title: 'cooperation.label.partnerCode',
            visible: true,
          },
        ],
      };
    },
    methods: {
      openDialog(data) {
        this.progress = 20;
        this.dialogVisible = true;
        this.propsData = data;
        this.check();
      },
      check() {
        const { partnerZhName, partnerEnName, creditCode, identityNo, id } = this.propsData;
        const params = { partnerZhName, partnerEnName, creditCode, identityNo, id };
        this.$axios.post(API.GET_CHECKING_PARTNER, params).then((res) => {
          if (res.data.code === 0) {
            this.progress = 100;
            this.checkedResult = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            this.status = 'exception';
          }
        });
      },
      handleClose() {
        this.progress = 0;
        this.status = null;
        this.checkedResult = [];
        this.dialogVisible = false;
      },
    },
  };
</script>

<style scoped>
  .check .result p {
    margin: 5px 0;
  }
</style>
